<div class="wrapper">
  <div class="auth-container">
    <div class="card">
      <div class="card__header">
        <h1 class="card__title">Join us</h1>
        <p class="card__description">
          To begin this journey, tell us what type of account you’d be opening.
        </p>
        <p class="card__org" *ngIf="tenantResolved; else unknownOrg">
          Organization: <strong>{{ orgName }}</strong>
        </p>
        <ng-template #unknownOrg>
          <p class="card__org card__org--warn">
            This address isn’t linked to a known organization.
          </p>
        </ng-template>
      </div>
      <div class="card__options">
        <button class="card__option"
                *ngFor="let option of options"
                (click)="onNavigate($event, option.type)">
          <img [alt]="option.title" [src]="option.icon" class="option-icon"/>
          <div class="option-description">
            <h4 class="option-title">{{ option.title }}</h4>
            <p class="option-description">{{ option.description }}</p>
          </div>
          <mat-icon class="icon-suffix">
            arrow_forward
          </mat-icon>
        </button>
      </div>
      <div class="card__footer">
        <p class="card__suggestion">Already have an account?</p>
        <div class="sign-in-options">
          <button mat-button class="card__link" (click)="login()">Sign in</button>
          <button mat-button class="card__link" (click)="loginAsEmployee()">Sign in as employee</button>
        </div>
      </div>
    </div>
  </div>
</div>
